import React from 'react';
import classNames from 'classnames';
import { BreadcrumbsItemsInterface } from 'interfaces/breadcrumbs.interface';

import './breadcrumbs-dropdown.scss';

const BreadcrumbsDropdownGroup: React.FC<{itemsGroup: BreadcrumbsItemsInterface[];}> = ({ itemsGroup }) => (
    <div className="breadcrumbs-dropdown__content__group">
        {
            itemsGroup.map(item => (
                <a
                    key={item.id}
                    href={item.url}
                    className={classNames({
                        'breadcrumbs-dropdown__content__group__link': true,
                        'breadcrumbs-dropdown__content__group__link--show-more': item.showMore
                    })}
                >
                    {item.showMore && !item.name ? 'Pokaż wszystkie' : item.name}
                </a>
            ))
        }
    </div>
);

export default BreadcrumbsDropdownGroup;
